import { DEFAULT_NOTE_TYPES, useGetAllNotesQuery, useGetAllPersonsQuery } from "@/services/api";
import { AppLoader } from "@/shared/Components";
import { NotesManagerContent } from "@/features/notes-manager";
import { useNotesManager } from "../model";

export const CommitmentsPage = () => {
  const { isLoading: isLoadingPersons } = useGetAllPersonsQuery();
  const { isLoading: isLoadingNotes } = useGetAllNotesQuery();
  const notesManager = useNotesManager();

  const isLoading = isLoadingPersons || isLoadingNotes;

  if (isLoading) return <AppLoader />;

  return (
    <NotesManagerContent
      notesManager={notesManager}
      noteType={DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT}
    />
  );
};
